import store from "@/store"
import translate from "../../../../languages"
let lang = localStorage.getItem('language') || store.state.language

const legends = {
  // Futebol
  6046: {
    10: translate[lang].firstHalf,
    20: translate[lang].secondHalf,
    30: translate[lang].firstHalfExtension,
    35: translate[lang].secondHalfExtension,
    50: translate[lang].sanctions,
    80: translate[lang].break,
    100: translate[lang].totalTime,
    101: translate[lang].fullPeriodAfterOvertime,
    102: translate[lang].fullPeriodAfterPenalties,
  },

  // Basquete
  48242: {
    '-1': translate[lang].matchNotStarted,
    1: translate[lang].firstQuarter,
    2: translate[lang].secondQuarter,
    3: translate[lang].thirdQuarter,
    4: translate[lang].fourthQuarter,
    40: translate[lang].overtime,
    80: translate[lang].break,
    100: translate[lang].totalTime,
    101: translate[lang].fullPeriodAfterOvertime,
  },

  // Tenis
  54094: {
    '-1': translate[lang].matchNotStarted,
    1: translate[lang].firstSet,
    2: translate[lang].secondSet,
    3: translate[lang].thirdSet,
    4: translate[lang].fourthSet,
    5: translate[lang].fifthSet,
    60: translate[lang].endOfMatch,
    80: translate[lang].break,
    100: translate[lang].totalTime,
  },

  // Volei
  154830: {
    '-1': translate[lang].matchNotStarted,
    1: translate[lang].firstSet,
    2: translate[lang].secondSet,
    3: translate[lang].thirdSet,
    4: translate[lang].fourthSet,
    5: translate[lang].fifthSet,
    50: translate[lang].goldenSet,
    80: translate[lang].break,
    100: translate[lang].totalTime,
  },

  // E-games
  687890: {
    '-1': translate[lang].matchNotStarted,
    1: translate[lang].firstMap,
    2: translate[lang].secondMap,
    3: translate[lang].thirdMap,
    4: translate[lang].fourthMap,
    5: translate[lang].fifthMap,
    80: translate[lang].break,
    100: translate[lang].totalTime,
  },

  // Luta
  154919: {
    '-1': translate[lang].matchNotStarted,
    1: translate[lang].firstRound,
    2: translate[lang].secondRound,
    3: translate[lang].thirdRound,
    4: translate[lang].fourthRound,
    5: translate[lang].fifthRound,
    6: translate[lang].sixtyRound,
    7: translate[lang].seventhRound,
    8: translate[lang].eighthRound,
    9: translate[lang].ninthRound,
    10: translate[lang].tenthRound,
    11: translate[lang].eleventhRound,
    12: translate[lang].twelfthRound,
    60: translate[lang].endOfMatch,
    80: translate[lang].break,
    100: translate[lang].totalTime,
  },

  // Futebol Americano
  131506: {
    '-1': translate[lang].matchNotStarted,
    1: translate[lang].firstMap,
    2: translate[lang].secondMap,
    3: translate[lang].thirdMap,
    4: translate[lang].fourthMap,
    5: translate[lang].fifthMap,
    80: translate[lang].break,
    100: translate[lang].totalTime,
  },

  // Tenis de Mesa
  265917: {
    '-1': translate[lang].matchNotStarted,
    1: translate[lang].firstSet,
    2: translate[lang].secondSet,
    3: translate[lang].thirdSet,
    4: translate[lang].fourthSet,
    5: translate[lang].fifthSet,
    60: translate[lang].endOfMatch,
    80: translate[lang].break,
    100: translate[lang].totalTime,
  },

  // Beisebol
  154914: {
    '-1': translate[lang].matchNotStarted,
    1: translate[lang].firstInning,
    2: translate[lang].secondInning,
    3: translate[lang].thirdInning,
    4: translate[lang].fourthInning,
    5: translate[lang].fifthInning,
    6: translate[lang].sixtyInning,
    7: translate[lang].seventhInning,
    8: translate[lang].eighthInning,
    9: translate[lang].ninthInning,
    40: translate[lang].extraInning,
    60: translate[lang].endOfMatch,
    80: translate[lang].break,
    100: translate[lang].totalTime,
  },

  // Vôlei de Praia
  621569: {
    '-1': translate[lang].matchNotStarted,
    1: translate[lang].firstSet,
    2: translate[lang].secondSet,
    3: translate[lang].thirdSet,
    80: translate[lang].break,
    100: translate[lang].totalTime,
  },

  //Futsal
  687887: {
    10: translate[lang].firstHalf,
    20: translate[lang].secondHalf,
    40: translate[lang].firstHalfExtension,
    45: translate[lang].secondHalfExtension,
    50: translate[lang].sanctions,
    80: translate[lang].break,
    100: translate[lang].totalTime,
    101: translate[lang].fullPeriodAfterOvertime,
    102: translate[lang].fullPeriodAfterPenalties,
  },

}

export default legends;